import { Input } from '@/components/Input'
import { THEME_PRICE } from '@/config/constants'
import { formatMoney } from '@/utils'
import { InteractiveLabel } from '../../components/InteractiveLabel'

import { useCakeMakerActions, useCakeMakerState } from '@/store/useCakeMaker'

import { Option } from '../../components/Option'
import { OptionsWrapper } from '../../components/OptionsWrapper'

import { batters } from '../../data/batters'
import { shapes } from '../../data/shapes'
import { weights } from '../../data/weights'

import './styles.scss'

export function AboutCakeStep() {
  const {
    theme,
    batter: selectedBatter,
    weight: selectedWeight,
    shape: selectedShape,
  } = useCakeMakerState()

  const { setTheme, setBatter, setWeight, setShape } = useCakeMakerActions()

  return (
    <div className="about-cake-step">
      <div className="about-cake-step__item">
        <InteractiveLabel
          htmlFor="theme"
          info={`Assim que digitar, será somado ${formatMoney(THEME_PRICE)} ao valor total`}
          priceBy={{ value: THEME_PRICE }}
        >
          Tema
        </InteractiveLabel>

        <Input
          id="theme"
          placeholder="Ex.: Homem Aranha, São Paulo FC, Meme..."
          name="name"
          type="text"
          onChange={(e) => setTheme(e.target.value)}
          value={theme}
        />
      </div>

      <div className="about-cake-step__item">
        <InteractiveLabel id="batter-label" required>
          Massa
        </InteractiveLabel>

        <OptionsWrapper aria-labelledby="batter-label">
          {batters.map((batter) => (
            <Option
              key={batter.id}
              value={batter.name}
              priceBy={{ value: batter.price, by: 'kg' }}
              onClick={() => setBatter(batter)}
              selected={batter.id === selectedBatter?.id}
            />
          ))}
        </OptionsWrapper>
      </div>

      <div className="about-cake-step__item">
        <InteractiveLabel id="weight-label" required>
          Peso
        </InteractiveLabel>

        <OptionsWrapper aria-labelledby="weight-label">
          {weights.map((weight) => (
            <Option
              key={weight.id}
              value={weight.value}
              onClick={() => setWeight(weight)}
              selected={weight.id === selectedWeight?.id}
              label={weight.description}
            />
          ))}
        </OptionsWrapper>
      </div>

      <div className="about-cake-step__item">
        <InteractiveLabel id="shape-label" required>
          Formato
        </InteractiveLabel>

        <OptionsWrapper aria-labelledby="shape-label">
          {shapes.map((shape) => (
            <Option
              key={shape.id}
              value={shape.name}
              onClick={() => setShape(shape)}
              selected={shape.id === selectedShape?.id}
              icon={shape.icon}
            />
          ))}
        </OptionsWrapper>
      </div>
    </div>
  )
}
